//dashboard
export const GET_LIST_CHECKIN = "GET_LIST_CHECKIN"
export const GET_ORDER_DETAIL = "GET_ORDER_DETAIL"
export const GET_LIST_ORDER_HISTORY = "GET_LIST_ORDER_HISTORY"
export const GET_REPORT_CHECKIN = "GET_REPORT_CHECKIN"
export const REMOVE_CHECKIN_ITEM = "REMOVE_CHECKIN_ITEM"
export const UPDATE_ORDER_STAFF = "UPDATE_ORDER_STAFF"
export const CHECK_PASSWORD = "CHECK_PASSWORD"
export const REMOVE_ORDER = "REMOVE_ORDER"
export const EXPORT_ORDER = "EXPORT_ORDER"
export const CHANGE_DELETE_STATUS = "CHANGE_DELETE_STATUS"
export const CHANGE_ALL_DELETE_STATUS = "CHANGE_ALL_DELETE_STATUS"
export const CALCULATE_ORDER = "CALCULATE_ORDER"
export const CHECK_GIFTCARD = "CHECK_GIFTCARD"
export const UPDATE_ORDER = "UPDATE_ORDER"
export const RESET_GIFT_CARD = "RESET_GIFT_CARD"
export const CANCEL_ORDER = "CANCEL_ORDER"

//time-keeping
export const GET_LIST_TIME_KEEPING = "GET_LIST_TIME_KEEPING"
export const ADD_TIME_KEEPING = "ADD_TIME_KEEPING"
export const UPDATE_TIME_KEEPING = "UPDATE_TIME_KEEPING"
export const REMOVE_TIME_KEEPING = "REMOVE_TIME_KEEPING"

//payroll
export const GET_PAYROLL_LIST = "GET_PAYROLL_LIST"
export const GET_PAYROLL_SETTING = "GET_PAYROLL_SETTING"
export const APPROVE_PAYROLL = "APPROVE_PAYROLL"
export const UPDATE_PAYROLL_SETTING = "UPDATE_PAYROLL_SETTING"
export const GET_DISCOUNT_SETTING = "GET_DISCOUNT_SETTING"
export const UPDATE_DISCOUNT_SETTING = "UPDATE_DISCOUNT_SETTING"
export const GET_CASH_DISCOUNT_SETTING = "GET_CASH_DISCOUNT_SETTING"
export const UPDATE_CASH_DISCOUNT_SETTING = "UPDATE_CASH_DISCOUNT_SETTING"
export const GET_INCOME_DETAIL = "GET_INCOME_DETAIL"
export const GET_APPROVE_PAYROLL = "GET_APPROVE_PAYROLL"
export const EXPORT_PAYROLL = "EXPORT_PAYROLL"
export const EXPORT_APPROVE_PAYROLL = "EXPORT_APPROVE_PAYROLL"
export const EXPORT_INCOME_DETAIL = "EXPORT_INCOME_DETAIL"
export const GET_SALARY_CHART = "GET_SALARY_CHART"
export const GET_SALARY_DETAIL = "GET_SALARY_DETAIL"

//ticket template
export const GET_TICKET_LIST = "GET_TICKET_LIST"
export const GET_BLOCK_LIST = "GET_BLOCK_LIST"
export const CREATE_TICKET_TEMPLATE = "CREATE_TICKET_TEMPLATE"
export const DELETE_TICKET_TEMPLATE = "DELETE_TICKET_TEMPLATE"
export const UPDATE_TICKET_TEMPLATE = "UPDATE_TICKET_TEMPLATE"
export const MOVE_SUBJECT = "MOVE_SUBJECT"
export const SET_DEFAULT_TICKET_TEMPLATE = "SET_DEFAULT_TICKET_TEMPLATE"

//batch history
export const GET_BATCH_HISTORY = "GET_BATCH_HISTORY";
export const GET_BATCH_DETAIL = "GET_BATCH_DETAIL";

//income history
export const GET_INCOME_HISTORY = "GET_INCOME_HISTORY";

//staff daily income
export const GET_STAFF_DAILY_INCOME = "GET_STAFF_DAILY_INCOME";